export default {
  // layout
  LAYOUT: {
    header: {
      ___webTitle: '網頁標題',
      ___functionMenu: '功能選單',
      ___userMenu: '用戶選單',
      functionMenu: {
        ___main: 'Main',
        ___mainIndex: 'MainIndex',
        ___index: 'Index',
        ___table: 'Table',
        ___grab: 'Grab',
        ___borCor: 'BorCor',
        ___treeMenu: 'Tree Menu',
        ___countup: 'Countup',
        ___util: 'Util'
      },
      userMenu: {
        ___login: '登入',
        ___logout: '登出'
      }
    },
    footer: {
      ___title: '頁尾'
    },
    uploading: {
      ___default: '檔案上傳中'
    },
    dialog: {
      login: {
        ___title: '使用者登入',
        form: {
          placeholder: {
            ___account: '帳號',
            ___password: '密碼',
            ___role: '選擇角色'
          },
          option: {
            role: {
              ___user: '用戶',
              ___admin: '管理員'
            }
          }
        }
      }
    }
  },
  // page
  PAGE: {
    main: {
      ___title: '主區塊'
    },
    index: {
      ___list: '列表{count}'
    },
    mainIndex: {
      ___top: '頂部',
      ___bottom: '底部'
    },
    table: {
      thead: {
        ___index: '#',
        ___name: '名稱',
        ___age: '年齡',
        ___date: '日期',
        ___noteA: '其他A',
        ___noteB: '其他B'
      }
    },
    util: {
      ___content: '內容'
    }
  },
  // component
  COMPONENT: {
  },
  // common
  COMMON: {
    button: {
      ___cancel: '取消',
      ___login: '登入',
      ___reset: '重置',
      ___select: '選擇',
      ___send: '送出',
      ___add: '新增',
      ___line: 'Line',
      ___grab: 'Grab',
      ___single: 'Single',
      ___multiple: 'Multiple',
      ___autoHeight: 'Auto Height'
    },
    toast: {
      ___noPermission: '權限不足',
      ___pleaseLogin: '請先登入',
      ___pageNotFound: '頁面不存在，或是權限不足'
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/lang/tc/lang.js